export default {
	FamilyMemberNameEntry: 67,
	Glia: 69,
	ReEnterSSNITIN: 78,
	HideNCUAFooterTextOnProductSelect: 83,
	HideNCUAFooterTextOnAllOtherPages: 84
};
